/**
 * @Auther: Qsan
 * @Date：2018年12月12日 16:30
 * @Desc：公用库统一安装
 */
import Vue from 'vue'
import moment from 'moment' // 时间格式化工具
import VueMoment from 'vue-moment' // 时间过滤器
import Cookies from 'js-cookie'
import env from './env'
import * as utils from './utils'
import axios from './http'
import params from './params'
import validate from './validate'
import * as filters from './filters'
import api from '../api'

Cookies.json = true

Vue.use(VueMoment, {
    moment
})
Vue.use(validate)
Vue.use(api)

/**
 * 全局注册过滤器
 * 将过滤器注册到全局
 */
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})

Vue.prototype.env = env
Vue.prototype.utils = utils
Vue.prototype.params = params
Vue.prototype.cookies = Cookies
Vue.prototype.http = axios



// WEBPACK FOOTER //
// ./src/common/index.js